import React, { PureComponent } from 'react';
import Carousel from 'react-multi-carousel';
import cn from 'classnames';

import { DeviceType } from '../../../../enums';
import { withBrowserInfo } from '../../../../hocs';
import { breakpointLGInt, breakpointSMInt } from '../../../../base-styles/vars';
import { TileImage } from './components/Tile';
import { TileType } from './components/Tile/utils/TileType';

import styles from './styles.module.css';
import './styles.css';

const MIN_TILES_TO_SHOW = 3;

const MAX_DESKTOP_ITEMS = 6;

const getCarouselResponsiveSettings = (numDesktopItems) => ({
  [DeviceType.DESKTOP]: {
    items: numDesktopItems,
    slidesToSlide: numDesktopItems,
    breakpoint: { min: breakpointLGInt, max: 10000 },
  },
  [DeviceType.TABLET]: {
    items: 3,
    slidesToSlide: 1,
    breakpoint: { min: breakpointSMInt, max: breakpointLGInt },
    partialVisibilityGutter: 25,
  },
  [DeviceType.MOBILE]: {
    items: 2,
    slidesToSlide: 1,
    breakpoint: { min: 0, max: breakpointSMInt },
    partialVisibilityGutter: 25,
  },
});

class TileImageCarousel extends PureComponent {
  constructor() {
    super();
    this.carouselRef = React.createRef();

    this.state = { isLeftArrowDisabled: true, isRightArrowDisabled: false };
  }

  onLeftClick = () => {
    const { onArrowClick = () => {} } = this.props;
    this.carouselRef.previous();
    onArrowClick({ type: 'left' });
  };

  onRightClick = () => {
    const { onArrowClick = () => {} } = this.props;
    this.carouselRef.next();
    onArrowClick({ type: 'rigt' }); // leave misspelled @product ryan
  };

  handleSlideChange = () => {
    const { currentSlide, slidesToShow, totalItems } = this.carouselRef.state;
    if (currentSlide === 0) {
      this.setState({ isLeftArrowDisabled: true });
    } else {
      this.setState({ isLeftArrowDisabled: false });
    }

    if (currentSlide + slidesToShow >= totalItems) {
      this.setState({ isRightArrowDisabled: true });
    } else {
      this.setState({ isRightArrowDisabled: false });
    }
  };

  render() {
    const {
      title,
      links,
      deviceType,
      isMobile,
      onTileClick = () => {},
    } = this.props;
    if (!links || links.length < MIN_TILES_TO_SHOW) {
      return null;
    }

    return (
      <div
        className={cn(
          styles.section,
          styles.relative,
          styles.imageCarouselContainer,
        )}
      >
        {title && <div className={styles.sectionTitle}>{title}</div>}
        <Carousel
          partialVisbile
          ssr
          arrows={false}
          ref={(el) => {
            this.carouselRef = el;
          }}
          responsive={getCarouselResponsiveSettings(
            Math.min(links.length, MAX_DESKTOP_ITEMS),
          )}
          deviceType={deviceType}
          afterChange={this.handleSlideChange}
        >
          {links.map(({ text, link, image }, index) => (
            <TileImage
              className={styles.tile}
              isMobile={isMobile}
              key={text}
              text={text}
              link={link}
              image={image}
              onClick={() =>
                onTileClick({ index, type: TileType.IMAGE, anchorText: text })
              }
            />
          ))}
        </Carousel>
        {links.length > MAX_DESKTOP_ITEMS && (
          <>
            {!this.state.isLeftArrowDisabled && (
              <i
                onKeyPress
                className={styles.leftArrow}
                onClick={this.onLeftClick}
              />
            )}
            {!this.state.isRightArrowDisabled && (
              <i
                onKeyPress
                className={styles.rightArrow}
                onClick={this.onRightClick}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

export default withBrowserInfo(TileImageCarousel);
